
import { __callbacks } from "Utils/Callbacks/Callback";
import styles from "./UserOption.module.scss";

export default function UserOption(props) {

  const onClick = () => {
    __callbacks.userOption.trigger(props.value);
    __callbacks.userResponse.trigger(props.id);
  }

  return (
    <div className={styles.container}>
      <span onClick={onClick} className={`config-user-option`}>{props.value}</span>
    </div>
  )
}
